import type * as CancelSubscription from '@ori-events/cancel-subscription';
import * as CancelSubscriptionFailed from '@ori-events/cancel-subscription-failed';
import type { PositionData } from '@ori/analytics-data';

import { convertToCamelCase, getHttpRequestSettings } from '../helpers';
import { RequestUrl } from '../models';

interface Data extends CancelSubscription.Data, PositionData {}

export const dispatchCancelSubscriptionFailedEvent = (detail: CancelSubscriptionFailed.Data) => {
  const event = new CustomEvent<CancelSubscriptionFailed.Data>(CancelSubscriptionFailed.Name, {
    detail,
  });
  window.dispatchEvent(event);
};

export default async ({
  detail: { consumerId, packageId, placement, subscriptionId },
}: CustomEvent<Data>) => {
  const request = await fetch(
    `${RequestUrl.CancelSubscription}?consumerId=${consumerId}&subscriptionId=${subscriptionId}&packageId=${packageId}`,
    getHttpRequestSettings({ placement }),
  );

  const response = convertToCamelCase<CancelSubscriptionFailed.CancelSubscriptionResponse>(
    (await request.json()) as object,
  );

  if (CancelSubscriptionFailed.isCancelSubscriptionErrorResponse(response)) {
    dispatchCancelSubscriptionFailedEvent(response);

    return false;
  }

  return response;
};
